<template>
  <ValidationObserver v-slot="{ validate, invalid }">
    <form
      @submit.prevent="validate().then(() => onSubmit(invalid))"
      class="find-property-manually"
    >
      <BaseLabel
        :class="hideDetails ? 'mt-10' : 'mt-3'"
        text="Postcode"
        :style="{ 'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%' }"
        actionBtnLabel="Use address finder"
        @click:actionBtn="$emit('useAddressFinder')"
      />
      <BaseInput
        name="postcode"
        v-model="address.PostCode.Value"
        :dataUiid="dataUiid ? `${dataUiid}PostCode_search` : ''"
        :style="{
          'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }"
        class="mt-2"
        :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
        :hide-details="hideDetails"
        :rules="{
          required: {
            required: true,
            fieldLabel: 'Postcode',
          },
          regex: {
            required: true,
            pattern:
              '^(?![Ii][Mm])(?![Jj][Ee])(?![Gg][Yy])[A-Za-z]{1,2}[0-9A-Za-z]{1,2} ?[0-9][A-Za-z]{2}$',
            customMessage: 'Please enter a valid postcode.',
          },
          is_duplicate_address_field: {
            street: '@street',
            district: '@district',
            town: '@town',
            county: '@county',
          },
        }"
        aria-label="Postcode"
      />

      <BaseLabel
        :class="hideDetails ? 'mt-9' : 'mt-3'"
        text="Property house number and street name"
      />
      <BaseInput
        name="street"
        v-model="address.Street.Value"
        :dataUiid="dataUiid ? `${dataUiid}Street` : ''"
        :style="{
          'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }"
        class="mt-2"
        :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
        :hide-details="hideDetails"
        :rules="{
          required: {
            required: true,
            fieldLabel: 'Property house number and street name',
          },
          regex: {
            required: true,
            pattern: '^[a-zA-Z0-9\\s\\-\\\'\\,\\.\\/]*$',
            customMessage:
              'Please enter only alphanumeric characters, spaces, or any of the following characters in this field - \' , . \/',
          },
          maxLength: {
            fieldLabel: 'Property house number and street name',
            length: maxLengthStreet,
          },
          is_duplicate_address_field: {
            postcode: '@postcode',
            district: '@district',
            town: '@town',
            county: '@county',
          },
        }"
        aria-label="Street"
      />

      <BaseLabel :class="hideDetails ? 'mt-9' : 'mt-3'" text="District" />
      <BaseInput
        name="district"
        v-model="address.District.Value"
        :dataUiid="dataUiid ? `${dataUiid}District` : ''"
        :style="{
          'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }"
        class="mt-2"
        :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
        :hide-details="hideDetails"
        :rules="{
          regex: {
            required: true,
            pattern: '^[a-zA-Z0-9\\s\\-\\\'\\,\\.\\/]*$',
            customMessage:
              'Please enter only alphanumeric characters, spaces, or any of the following characters in this field - \' , . \/',
          },
          maxLength: {
            fieldLabel: 'District',
            length: 30,
          },
          is_duplicate_address_field: {
            postcode: '@postcode',
            street: '@street',
            town: '@town',
            county: '@county',
          },
        }"
        aria-label="District"
      />

      <BaseLabel :class="hideDetails ? 'mt-9' : 'mt-3'" text="Town" />
      <BaseInput
        name="town"
        v-model="address.Town.Value"
        :dataUiid="dataUiid ? `${dataUiid}Town` : ''"
        :style="{
          'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }"
        class="mt-2"
        :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
        :hide-details="hideDetails"
        :rules="{
          required: {
            required: true,
            fieldLabel: 'Town',
          },
          regex: {
            required: true,
            pattern: '^[a-zA-Z0-9\\s\\-\\\'\\,\\.\\/]*$',
            customMessage:
              'Please enter only alphanumeric characters, spaces, or any of the following characters in this field - \' , . \/',
          },
          maxLength: {
            fieldLabel: 'Town',
            length: 30,
          },
          is_duplicate_address_field: {
            postcode: '@postcode',
            street: '@street',
            district: '@district',
            county: '@county',
          },
        }"
        aria-label="Town"
      />

      <BaseLabel :class="hideDetails ? 'mt-9' : 'mt-3'" text="County" />
      <BaseInput
        name="county"
        v-model="address.County.Value"
        :dataUiid="dataUiid ? `${dataUiid}County` : ''"
        :style="{
          'max-width': $vuetify.breakpoint.lgAndUp ? '480px' : '100%',
        }"
        class="mt-2"
        :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
        :hide-details="hideDetails"
        :rules="{
          regex: {
            required: true,
            pattern: '^[a-zA-Z0-9\\s\\-\\\'\\,\\.\\/]*$',
            customMessage:
              'Please enter only alphanumeric characters, spaces, or any of the following characters in this field - \' , . \/',
          },
          maxLength: {
            fieldLabel: 'County',
            length: 30,
          },
          is_duplicate_address_field: {
            postcode: '@postcode',
            street: '@street',
            district: '@district',
            town: '@town',
          },
        }"
        aria-label="County"
      />

      <BaseButton
        depressed
        name="save"
        text="SAVE ADDRESS"
        rounded
        :block="$vuetify.breakpoint.lgAndUp ? false : true"
        dense
        color="psdarkgreen"
        text-color="white--text"
        :class="{ 'mt-5': hideDetails }"
        class="font-weight-bold font-20 pa-7 px-13 mb-10"
        type="submit"
        height="60"
        :min-width="$vuetify.breakpoint.lgAndUp ? '324' : '100%'"
        aria-label="Save address"
      />
    </form>
  </ValidationObserver>
</template>

<script>
import { dereference } from "@/common/transforms";
import BaseButton from "@/components/BaseComponents/BaseButton";
import BaseInput from "@/components/BaseComponents/BaseInput";
import BaseLabel from "@/components/BaseComponents/BaseLabel";
import { ValidationObserver } from "vee-validate";

export default {
  name: "AddressManualEntryForm",
  props: {
    addressData: {
      type: Object,
      required: false,
    },
    hideDetails: {
      type: [String, Boolean],
      default: "auto",
    },
    maxLengthStreet: {
      type: Number,
      default: 30,
    },
    dataUiid: String,
  },
  components: {
    BaseInput,
    BaseLabel,
    BaseButton,
    ValidationObserver,
  },
  watch: {
    addressData(value) {
      if (value) {
        this.address = dereference(value);
      }
    },
  },
  data() {
    return {
      address: {
        PostCode: { Value: "" },
        Street: { Value: "" },
        District: { Value: "" },
        Town: { Value: "" },
        County: { Value: "" },
      },
    };
  },
  mounted() {
    if (this.addressData) {
      this.address = dereference(this.addressData);
    }
  },
  methods: {
    onSubmit(invalid) {
      if (invalid) {
        const documentSaveManuallyError = document.querySelector(
          "form.find-property-manually div.error--text"
        );
        if (documentSaveManuallyError) {
          setTimeout(() => {
            const input = documentSaveManuallyError?.querySelector("input");
            input?.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
          }, 100);
        }
        return;
      }
      this.$emit("formSubmitted", this.address);
    },
  },
};
</script>
